"use client";

import { signIn } from "next-auth/react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";

interface SocialLoginsProps {
  callbackUrl: string;
  fleetMode?: boolean;
}

export function SocialLogins({ callbackUrl, fleetMode = false }: SocialLoginsProps) {
  return (
    <div className="mt-6">
      <div className="relative">
        <div className="relative flex justify-center">
          <span 
            className="px-3 text-xs uppercase tracking-wide"
            style={fleetMode ? { 
              background: 'var(--fleet-panel)', 
              color: 'var(--fleet-muted)' 
            } : { 
              background: 'var(--card)', 
              color: 'var(--muted-foreground)' 
            }}
          >
            Or continue with
          </span>
        </div>
      </div>
      <div className={`mt-6 ${fleetMode ? '' : 'grid grid-cols-2 gap-2'}`}>
        <Button
          variant="outline"
          onClick={() => signIn("google", { callbackUrl })}
          className="flex items-center justify-center gap-2 w-full transition-all duration-200 hover:scale-105 hover:shadow-md"
          style={fleetMode ? {
            background: 'var(--fleet-subtle)',
            border: '1px solid var(--fleet-border)',
            color: 'var(--fleet-text)'
          } : undefined}
        >
          <span aria-hidden>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4.8c1.98 0 3.76.68 5.17 1.81l3.45-3.45C17.98 1.1 15.16 0 12 0 7.32 0 3.28 2.69 1.26 6.6l4.14 3.21C6.44 7.14 8.99 4.8 12 4.8z" fill="#EA4335"/>
              <path d="M23.64 12.27c0-.84-.08-1.64-.23-2.41H12v4.58h6.54c-.28 1.48-1.12 2.73-2.37 3.58l3.62 2.81c2.11-1.95 3.35-4.83 3.35-8.56z" fill="#4285F4"/>
              <path d="M5.4 14.14a7.2 7.2 0 010-4.28L1.26 6.6A12 12 0 000 12c0 1.95.47 3.79 1.26 5.4l4.14-3.26z" fill="#FBBC05"/>
              <path d="M12 24c3.24 0 5.96-1.07 7.95-2.91l-3.62-2.81c-1 .68-2.28 1.08-3.74 1.08-3.01 0-5.56-2.34-6.6-5.4l-4.14 3.21C3.28 21.31 7.32 24 12 24z" fill="#34A853"/>
            </svg>
          </span>
          Google
        </Button>
      </div>
    </div>
  );
}